import { Component, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';
import { Subscription } from 'rxjs';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { IssueOrderSupplierType, IssueSupplier, IssuesFilterSupplier, IssuesOrderSupplier, QuproList, QuproServiceError, QuproServiceErrorType, SupplierAgreementUploaded } from '@arpada/arp-lib-common-qupro';
import { IssueFront, Constants, Page, DatatableMessage, IIssueFrontSelection, ModeloError, ISignedData } from '../../models/api.models';

import { SignatureWidgetComponent } from '../shared/signature-widget/signature-widget.component';
import { MessagesService, PortalProveedorService, UiService, GeneralPopulateService, IssuePopulateService } from '../../services/api.services';
import { IssueData } from '../shared/issue.data';

@Component({
  selector: 'app-issues-mantenimiento',
  templateUrl: './issues-mantenimiento.component.html',
  styleUrls: ['./issues-mantenimiento.component.scss'],
})
export class IssuesMantenimientoComponent implements OnInit, OnDestroy {

  sharedData: ActionsSharedData = new ActionsSharedData();
  issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
  issuesToEdit: IssueSupplier[] = [];
  filtroIssue = true;
  showEditOperarioButton = false;
  showListButton =  false;
  showCardListButton = true;
  comeFromIssue = true;
  issuesSelected = false;
  idsFilterIssues: number[] = [];
  showList = true;
  showCardList = false;
  showInlineEditionMenu: boolean ;
  showInlineEdit = false;
  showInlineEditButton = true;
  showSelectAllCards: boolean;
  showEdMasivaButton = false;
  edMasivaErrors: ModeloError [] = [];
  issueMantenimientoData: IssueData = new IssueData();
  idsSelected = -1;
  issuesOrder: IssuesOrderSupplier = new IssuesOrderSupplier(IssueOrderSupplierType.DEFAULT_ORDER);
  totalCount = '-';
  totalCountNumber = -1;
  allCardsSelected = false;
  issues: IssueSupplier[];
  totalCountIssuesToSelect = 0;
  offsetInfiniteScroll: number;
  mode = 'portal-proveedor';
  showExitInlineEditButton = false;
  allCardsSelectButton = true;
  fromWhere = 'mantenimiento';

  private operatorSelectSubscription: Subscription;
  private operatorUpdatedSubscription: Subscription;
  private selectOperatorSubscription: Subscription;
  private edicionMasivaErrorSubscription: Subscription;
  private edicionMasivaSubscription: Subscription;
  private selectionCardSubscription: Subscription;
  


  constructor(
    public alertController: AlertController,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private messagesService: MessagesService,
    private portalProveedorService: PortalProveedorService,
    private uiService: UiService,
    private generalPopulateService: GeneralPopulateService,
    private issuePopulateService: IssuePopulateService,
    private platform: Platform
  ) {
    this.initFilter();
    this.initIssueMantenimientoData();
    this.initPage();
    this.setHeight(this.platform.height());
  }

  ngOnInit() {
    const modoVista = localStorage.getItem('modoVista');
    this.showModoVista(modoVista);
    this.offsetInfiniteScroll = this.issueMantenimientoData.page.offset;
    this.setTotalCount(-1);
    this.setIdsSelectedNumber(-1);
    this.fromWhere = 'mantenimiento';
    this.messagesService.onInitTranslateService().subscribe( () => {
      this.getIssues(this.issueMantenimientoData.page);
    });

    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    this.selectOperator(operatorIdSelected);
    this.operatorSelectSubscription = this.portalProveedorService.onChangeOperatorSelected(this.selectOperator);
    this.operatorUpdatedSubscription = this.portalProveedorService.updateOperatorEvent.subscribe((issuesUpdated: IssueFront[]) => {
      this.onUpdateOperatorEvent(issuesUpdated);
    });
    this.selectOperatorSubscription = this.portalProveedorService.selectOperatorEvent.subscribe(operatorId => {
      this.issuesFilter.operator_num = operatorId;
      this.getIssues(this.issueMantenimientoData.page);
    });
    this.edicionMasivaErrorSubscription = this.portalProveedorService.errorEdicionMasivaEvent.subscribe((modeloError: ModeloError) => {
      this.edMasivaErrors.push(modeloError);
    });
    this.edicionMasivaSubscription = this.portalProveedorService.edicionMasivaEvent.subscribe((issueId: number) => {
      this.onEdMasivaEvent(issueId);
    });
    this.selectionCardSubscription = this.portalProveedorService.selectionCardEvent
    .subscribe((issueFrontSelection: IIssueFrontSelection) => {
      this.issueMantenimientoData.issuesFront.forEach((issueFront: IssueFront) => {
        if (issueFrontSelection.selection) {
          if (issueFront.id === issueFrontSelection.id) {
          this.sharedData.issuesFrontIdsSelected.push(issueFrontSelection.id);
          }
        } else {
          this.sharedData.issuesFrontIdsSelected = this.removeItemFromArray(this.sharedData.issuesFrontIdsSelected, issueFrontSelection.id);
        }
      });
      if (this.sharedData.issuesFrontIdsSelected.length === 0) {
        this.idsFilterIssues = [];
        this.setIdsSelectedNumber(-1);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.operatorSelectSubscription) {
      this.operatorSelectSubscription.unsubscribe();
    }
    if (this.operatorUpdatedSubscription) {
      this.operatorUpdatedSubscription.unsubscribe();
    }
    if (this.selectOperatorSubscription) {
      this.selectOperatorSubscription.unsubscribe();
    }
    if (this.edicionMasivaErrorSubscription) {
      this.edicionMasivaErrorSubscription.unsubscribe();
    }
    if (this.edicionMasivaSubscription) {
      this.edicionMasivaSubscription.unsubscribe();
    }
    if (this.selectionCardSubscription) {
      this.selectionCardSubscription.unsubscribe();
    }
  }

  onEdMasivaEvent(issueId: number) {
    this.sharedData.issuesIdsEditadasMasivamente.push(issueId);
    this.getIssues(this.issueMantenimientoData.page);
  }

  private getIssues(page: Page, event?, doAppend?: boolean, comeFromAllSelected?: boolean, selectAll?: boolean) {
    const start = page.offset * page.limit;
    const limit = page.limit;
    if (!doAppend) {
      this.issueMantenimientoData.issuesFront = [];
      this.sharedData.issuesFrontIdsSelected = [];
      this.setIdsSelectedNumber(-1);
    }
    this.issueMantenimientoData.idsFilterIssues = [];
    this.issueMantenimientoData.msg.emptyMessage = this.generalPopulateService.changeMms(true);
    this.issueMantenimientoData.loading = true;
    this.portalProveedorService.getMantenimientoIssuesFromCsiteSupplier(this.issuesFilter,
      this.issuesOrder, start, limit).subscribe((resp: QuproList<IssueSupplier>) => {
        this.setTotalCount(resp.count);
        this.issues = resp.elements;
        this.totalCountIssuesToSelect = resp.count;
        this.issueMantenimientoData.page.count = resp.count;
        if (!doAppend) {
          this.issueMantenimientoData.issuesFront = this.issuePopulateService.convertirIssuesToPostsaleFrontIssues(this.issues);
          this.issueMantenimientoData.rowsModelDataToUpdate =
                      this.issuePopulateService.createRowsModelToUpdate(this.issueMantenimientoData.issuesFront);
        } else {
          if (this.issues != null && this.issues.length > 0) {
            this.issues.forEach((issue: IssueSupplier) => {
              this.issueMantenimientoData.issuesFront.push(this.issuePopulateService.convertirIssueSupplierToPostsaleFrontIssue(issue));
            });
          }
        }
        this.issueMantenimientoData.idsFilterIssues = this.idsFilterIssues;
        this.issueMantenimientoData.loading = false;
        this.issueMantenimientoData.msg.emptyMessage = this.generalPopulateService.changeMms(false);
        if (event) {
          event.target.complete();
        }
        if (comeFromAllSelected) {
          this.sharedData.issuesFrontIdsSelected = [];
          this.allCardsSelected = selectAll;
          if (!selectAll) {
            this.setIdsSelectedNumber(-1);
            this.portalProveedorService.selectionAllCardsEvent.emit(selectAll);
          } else {
            this.setIdsSelectedNumber(this.issueMantenimientoData.issuesFront.length);
            this.portalProveedorService.selectionAllCardsEvent.emit(selectAll);
          }
        }
      });
  }

  onUpdateOperatorEvent(updateIssues: IssueFront[]) {
    this.issueMantenimientoData.issuesFront.forEach(issueFront => {
      updateIssues.forEach(updateIssue => {
        if (issueFront.id === updateIssue.id) {
          Object.assign(issueFront, updateIssue);
        }
      });
    });
    this.issueMantenimientoData.rowsModelDataToUpdate =
                      this.issuePopulateService.createRowsModelToUpdate(this.issueMantenimientoData.issuesFront);
  }

  onFilterChange(filtroRecibido) {
    this.sharedData.issuesFrontIdsSelected = [];
    this.showEditOperarioButton = false;
    this.issuesToEdit = [];
    this.idsFilterIssues = [];
    this.issueMantenimientoData.idsFilterIssues = [];
    this.issueMantenimientoData.selected = [];
    this.setTotalCount(-1);
    const filterTemp = new IssuesFilterSupplier();
    Object.assign(filterTemp, filtroRecibido);
    this.issuesFilter = filterTemp;
    this.issuesSelected = false;
    this.showEdMasivaButton = false;
    this.setIdsSelectedNumber(-1);
    this.initIssueMantenimientoData();
    this.initPage();
    this.getIssues(this.issueMantenimientoData.page);
  }

  onSelectAllPressed(selectAllPressed: Event) {
    this.sharedData.issuesFrontIdsSelected = [];
    this.setIdsSelectedNumber(-1);
    const page: Page = new Page();
    page.limit = 0;
    page.offset = 0;
    if (selectAllPressed) {
      this.allCardsSelectButton = false;
      this.getIssues(page, null, null, true, true);
    } else {
      this.allCardsSelectButton = true;
      this.allCardsSelected = false;
      this.idsFilterIssues = [];
      this.setIdsSelectedNumber(-1);
      this.getIssues(page, null, null, true, false);
    }

  }


  onFirmIssuesEvent(issueIdsToFirm: number[]) {
    const issueIdsCanNotfirm: number[] = [];
    const issuesToFirm: number[] = [];
    const housesIds: number[] = [];
    issueIdsToFirm.forEach((issueId: number) => {
      this.issueMantenimientoData.issuesFront.forEach((issueFront: IssueFront) => {
        if (issueId === issueFront.id) {
          if (issueFront.owner_conform !== 1) {
            issueIdsCanNotfirm.push(issueId);
          } else {
            issuesToFirm.push(issueId);
          }
          housesIds.push(issueFront.house_id);
        }
      });
    });
    const filterHousesIds = housesIds.filter((id, index) => housesIds.indexOf(id) === index);
    if (filterHousesIds.length > 1) {
      this.showMultiHouseError();
    } else {

      if (issueIdsCanNotfirm.length > 0) {
        this.showErrorAlert(issueIdsCanNotfirm);
      }
      if (issuesToFirm.length > 0) {
        this.conformOk(issuesToFirm);
      }
    }
  }

  async conformOk(issuesToFirm: number[]) {
    const signedEvent: EventEmitter<ISignedData> = new EventEmitter();
    const modal = await this.modalCtrl.create({
      component: SignatureWidgetComponent,
      componentProps: {
        infoText: this.messagesService.getSupplierConformInfoTextToSeveralIssues(issuesToFirm),
        signed: signedEvent,
      }
    });
    signedEvent.subscribe((eventData: ISignedData) => {
      this.portalProveedorService.supplierAgreement(eventData.signatureName, eventData.signatureVat,
        issuesToFirm, eventData.base64, eventData.mimetype)
          .subscribe(
            (supplierAgreementUploaded: SupplierAgreementUploaded) => {
              this.uiService.logger.debug('[IssueCardComponent.conformOk] Done: ', supplierAgreementUploaded);
              this.getIssues(this.issueMantenimientoData.page);
            },
            (error: QuproServiceError) => {
              this.uiService.logger.error('[IssueCardComponent.conformOk] Error: ', error);
              if (error && error.type !== QuproServiceErrorType.UNATHORIZED && error.type !== QuproServiceErrorType.QUPRO_ERROR) {
                this.uiService.showSimpleMiddleToast(this.messagesService.getCanNotUpdateIssueError(), 5000);
              } else if (error && error.type === QuproServiceErrorType.QUPRO_ERROR) {
                this.uiService.showSimpleMiddleToast(error.message, 5000);
              }
          });
    });
    return await modal.present();
  }

  async showErrorAlert(issueIdsCanNotfirm: number[]) {
    const alert = await this.alertController.create({
      header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
      message: 'No puede firmar las incidencias: ' + issueIdsCanNotfirm,
      buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
    });
    await alert.present();
  }

  async showMultiHouseError() {
    const alert = await this.alertController.create({
      header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
      message: 'No puede firmar incidencias de distintas viviendas.',
      buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
    });
    await alert.present();
  }

  onExitEdMasivaErrorPressed(event: Event) {
    this.edMasivaErrors = [];
  }

  onInlineEditPressed(event: Event) {
    this.showInlineEdit = true;
    this.showList = false;
    this.showCardListButton = false;
    this.showListButton = false;
    this.showCardList = false;
    this.showInlineEditButton = false;
    this.showExitInlineEditButton = true;
  }

  onExitInlineEditPressed(event: Event) {
    this.showInlineEdit = false;
    this.showInlineEditButton = true;
    this.showList = true;
    this.showCardList = false;
    this.showListButton = false;
    this.showCardListButton = true;
    this.showExitInlineEditButton = false;
  }


  onListPressed(event: Event) {
    // console.log('onListPressed');
    this.issuesToEdit = [];
    this.showEditOperarioButton = false;
    this.showListButton = false;
    this.showCardListButton = true;
    this.showList = true;
    this.showCardList = false;

    this.showInlineEdit = false;
    this.showInlineEditButton = true;
    this.showInlineEditionMenu = true;

    this.showSelectAllCards = false;
    this.sharedData.issuesFrontIdsSelected = [];
    this.sharedData.idsSelected = '-';
    this.issuesSelected = false;
    this.showEdMasivaButton = true;
    
  }

  onCardListPressed(event: Event) {
    // console.log('onCardListPressed');
    this.issuesToEdit = [];
    this.showEditOperarioButton = false;
    this.showListButton = true;
    this.showCardListButton = false;
    this.showList = false;
    this.showCardList = true;
    this.offsetInfiniteScroll = 0; // al cambiar de vista inicializo el offset

    this.showInlineEdit = false;
    this.showInlineEditButton = true;
    this.showInlineEditionMenu = false;

    this.showSelectAllCards = true;
    this.sharedData.issuesFrontIdsSelected = [];
    this.sharedData.idsSelected = '-';
    this.issuesSelected = false;
    this.showEdMasivaButton = false;
  }

  onUpdateEvent(updateIssue: IssueFront) {
    this.updateFrontIssue(updateIssue);
  }

  private updateFrontIssue(updateIssue: IssueFront) {
    this.issueMantenimientoData.issuesFront.forEach(issueFront => {
      if (issueFront.id === updateIssue.id) {
        Object.assign(issueFront, updateIssue);
      }
    });
  }

  doInfinite(event) {
    // crearme nueva pagina multplo 4 por tema de MD
    const cardPage: Page = new Page();
    cardPage.offset = 0;
    cardPage.limit = 10;
    cardPage.count = 0;
    ++this.offsetInfiniteScroll;
    cardPage.offset = this.offsetInfiniteScroll;
    this.getIssues(cardPage, event, true);
  }

  onGetIssues(envio) {
    this.getIssues(envio.page);
    this.setTotalCount(envio.total);
  }

  onRowSelected(event: IssueFront[]) {
    this.idsFilterIssues = [];
    this.issuesSelected = false;
    if (event.length > 0) {
      this.showEditOperarioButton = true;
      this.issuesToEdit = this.issuePopulateService.convertFrontIssuesToIssueSupplier(event, this.issues);
      // para hojas de trabajo: en este caso en vez del filtro se pasa en el filter
      // ids
      this.issuesToEdit.forEach(issue => {
        this.idsFilterIssues.push(issue.id);
      });
      this.issuesSelected = true;
      this.setIdsSelectedNumber(this.idsFilterIssues.length);
      this.showEdMasivaButton = true;
    } else {
      this.showEditOperarioButton = false;
      this.issuesSelected = false;
      this.setIdsSelectedNumber(-1);
      this.showEdMasivaButton = false;
    }
  }

  onIssueUpdateInlineEvent(updateIssue: IssueFront) {
    this.updateFrontIssue(updateIssue);
  }

  private setIdsSelectedNumber(idsSelected: number) {
    this.idsSelected = idsSelected;
    if (idsSelected >= 0) {
      this.sharedData.idsSelected = idsSelected + '';
      this.showEdMasivaButton = true;
    } else {
      this.sharedData.idsSelected = '-';
      this.showEdMasivaButton = false;
    }
  }

  private setTotalCount(totalCountNumber: number) {
    this.totalCountNumber = totalCountNumber;
    if (totalCountNumber >= 0) {
      this.totalCount = totalCountNumber + '';
      this.sharedData.totalCount = totalCountNumber + '';
    } else {
      this.totalCount = '-';
      this.sharedData.totalCount = '-';
    }
  }

  private initPage() {
    this.issueMantenimientoData.page.offset = 0;
    this.issueMantenimientoData.page.limit = 10;  // por defecto, ya que para los distintos tamannos tenemos que calcularlo.
    this.issueMantenimientoData.page.count = 0;
  }

  private initIssueMantenimientoData() {
    this.issueMantenimientoData.issuesFront = [];
    this.issueMantenimientoData.selected = [];
    this.issueMantenimientoData.page = new Page();
    this.issueMantenimientoData.idsFilterIssues = [];
    this.issueMantenimientoData.loading = true;
    this.issueMantenimientoData.msg = new DatatableMessage();
    this.issueMantenimientoData.msg.emptyMessage = '';
    this.issueMantenimientoData.msg.totalMessage = 'total';
  }

  private initFilter(csiteId?: number) {
    const newFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
    newFilter.setStateGroupKeys(Constants.SUPPLIER_POSTSALE_STATES_GROUPS_INIT_FILTER);
    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    if (operatorIdSelected) {
      newFilter.operator_num = operatorIdSelected;
    }
    // Assign all fields to actual filter
    Object.assign(this.issuesFilter, newFilter);
  }

  private setHeight(height: number) {
    if (height <= 650) {
      this.issueMantenimientoData.page.limit = 6;
    }
    if (height > 650 && height <= 736) {
      this.issueMantenimientoData.page.limit = 7;
    }
    if (height > 736 &&  height <= 823) {
      this.issueMantenimientoData.page.limit = 9;
    }
    if (height > 850) {
      this.issueMantenimientoData.page.limit = 10;
    }
  }

  private showModoVista(modoVista: string) {
    if (modoVista === 'cards') {
      this.onCardListPressed(null);
      this.showSelectAllCards = true;
    }
    if (modoVista === 'escritorio') {
      this.onListPressed(null);
      this.showSelectAllCards = false;
    }
  }

  private selectOperator = (id: number) => {
    if (id > 0) {
      this.issuesFilter.operator_num = id;
    }
  }

  private removeItemFromArray(arr: number[], item: number): number[] {
    return arr.filter((e) => {
      return e !== item;
    });
  }

}
